/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Groepeertype_Heterogeen3Inputs */

const nl_enums_groepeertype_heterogeen3 = /** @type {(inputs: Enums_Groepeertype_Heterogeen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heterogeen`)
};

/**

* @param {Enums_Groepeertype_Heterogeen3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_groepeertype_heterogeen3 = /** @type {((inputs?: Enums_Groepeertype_Heterogeen3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Groepeertype_Heterogeen3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_groepeertype_heterogeen3(inputs)
});
export { enums_groepeertype_heterogeen3 as "enums.GroepeerType.Heterogeen" }